import Chip, { ChipProps } from "@mui/material/Chip";
import React from "react";

export interface ConnectionStateConfig {
  label: string;
  color: ChipProps["color"];
  overrideColor?: string;
  value?: string;
  icon?: React.ReactElement;
  variant?: ChipProps["variant"];
}

export interface ConnectionStateChipProps {
  state: string;
  stateConfig: Record<string, ConnectionStateConfig>;
  disabled?: boolean;
  onClick?: () => void;
  size?: ChipProps["size"];
  sx?: ChipProps["sx"];
}

export const ConnectionStateChip: React.FC<ConnectionStateChipProps> = ({
  state,
  stateConfig,
  onClick,
  size = "small",
  sx,
  disabled = false
}) => {
  const config = stateConfig[state];

  if (!config) {
    console.warn(`ConnectionStateChip: No configuration found for state "${state}"`);
    return null;
  }

  return (
    <Chip
      data-testid="toggle-live-update"
      component="button"
      value={config.value}
      label={config.label}
      color={config.color}
      icon={config.icon}
      variant={config.variant || "filled"}
      size={size}
      onClick={onClick}
      sx={sx}
      disabled={disabled}
    />
  );
};
